import { useEffect, useState } from "react";
import Stack from "@mui/material/Stack";
import { getReuniones } from "../componentes/api.js";
import Alert from "@mui/material/Alert";
import Streaming from "./Streaming.jsx";
import Card from "react-bootstrap/Card";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import Chip from "@mui/material/Chip";
import Divider from "@mui/material/Divider";
import AccessTimeFilledIcon from "@mui/icons-material/AccessTimeFilled";
import Button from "react-bootstrap/esm/Button.js";

const SalaVideo = (props) => {
  let nbres = props.nbres;
  let hoy = new Date().toISOString().substring(0, 10);

  const [reuniones, setReuniones] = useState([]);
  const [idStreaming, setIdStreaming] = useState("");

  useEffect(() => {
    setIdStreaming("");
    cargarReuniones();
  }, []);

  const cargarReuniones = async () => {
    try {
      const response = await getReuniones(props.idProyecto);
      setReuniones(response.data);
    } catch (error) {
      props.mostrarMsg(["ERROR", "Ocurrio un error al Autenticarse!", error]);
    }
  };

  const descargarListado = (event) => {
    event.preventDefault();
    props.mostrarMsg(["Ok, descargará el listado de asistencia de la Reunión"]);
  };

  const iniciarStreaming = (event, id) => {
    event.preventDefault();
    setIdStreaming(id);
  };

  const mostrarEstado = (estado, activo) => {
    let msg = "";
    if (estado === 0 && activo === 0) msg = "ANULADA";
    else if (estado === 0 && activo === 1) msg = "Pendiente - Activa";
    else if (estado === 1 && activo === 0) msg = "ANULADA";
    else if (estado === 1 && activo === 1) msg = "Ejecutada";
    return msg;
  };

  return (
    <div className="container">
      <div className="row mt-3 mb-3">
        <Stack sx={{ width: "100%" }} spacing={2}>
          <Alert severity="success">
            <strong>SALA DE REUNION</strong>
          </Alert>
        </Stack>
      </div>

      {idStreaming === "" ? (
        <div className="row mt-3 mb-3">
          {reuniones.length > 0 &&
            reuniones.map((reg, i) => {
              return (
                <div className="mt-2" key={i}>
                  <Card>
                    <Card.Body>
                      <Card.Title>
                        {i + 1}. {reg.Nbre}
                      </Card.Title>
                      <Card.Subtitle className="mb-2 text-muted">
                        {reg.TipoProyecto}
                      </Card.Subtitle>

                      <Card.Subtitle className="mb-2 text-muted mb-3 mt-3">
                        <CalendarMonthIcon />{" "}
                        {reg.Fecha.toString().substring(0, 10)} <br />
                        <AccessTimeFilledIcon />{" "}
                        {reg.Hora.toString().substring(0, 10)}
                        <br />
                        Estado: {mostrarEstado(reg.Estado, reg.Activo)}
                        <br className="mb-3" />
                      </Card.Subtitle>
                      {reg.Activo === 1 && reg.Estado === 1 && (
                        <Card.Subtitle className="mb-2 text-muted mb-3 mt-3">
                          <Button onClick={(event) => descargarListado(event)}>
                            Descargar Listado de Asistencia
                          </Button>
                        </Card.Subtitle>
                      )}
                      <Divider className="mb-4 mt-3" />

                      {hoy === reg.Fecha.toString().substring(0, 10) && (
                        <blockquote className="blockquote mb-0 mt-3">
                          <footer className="blockquote-footer">
                            <cite title="Ingresar">
                              <Chip
                                label="Ingresar a la sala de reunión"
                                color="primary"
                                variant="outlined"
                                onClick={(event) =>
                                  iniciarStreaming(event, reg.Id)
                                }
                              />
                            </cite>
                          </footer>
                        </blockquote>
                      )}
                    </Card.Body>
                  </Card>
                </div>
              );
            })}
        </div>
      ) : (
        <Streaming
          idUsuario={props.idUsuario}
          nbres={nbres}
          tipoParticipante={props.tipoParticipante}
          socket={props.socket}
        />
      )}
    </div>
  );
};

export default SalaVideo;
